/**
 * Project progress docs — RETIRÉ du bundle client (Chunk 9.V.2c-PMG, finding S4).
 *
 * 9.R.1 exposait 3 docs internes (`PROJECT_STATUS.md`, `docs/DETTES.md`,
 * `docs/PLAN_GLOBAL.md`) via `import("…?raw")` : Vite embarquait leur **contenu
 * intégral** dans des chunks JS statiques, récupérables sans authentification
 * (les assets/chunks ne sont pas auth-gated). Ces docs sont ops/dev internes →
 * aucun n'est « client-safe ». L'allowlist client-safe est donc VIDE et la
 * fonctionnalité de visualisation est retirée (bloqueur pré-merge PR #18).
 *
 * Conséquences :
 *  - Aucun `import("…?raw")` de doc interne → plus rien dans les chunks/sourcemaps.
 *  - `VERSION_MENU_LINKS` ne conserve que le lien « Tests & Qualité » (rapport JSON
 *    curé `quality-report.json`, hors périmètre S4).
 *  - `/internal/progress/:slug` redirige vers 404 (cf. `ProjectProgressPage`).
 *
 * Réintroduction future (si besoin produit) : servir un doc EXPLICITEMENT
 * client-safe via un endpoint backend authentifié (jamais un `?raw` bundlé).
 */

export type VersionMenuLink = {
  /** Path interne (littéral, allowlist) */
  readonly href: string;
  /** i18n key pour le label menu + page title */
  readonly i18nKey: string;
};

export const VERSION_MENU_LINKS: ReadonlyArray<VersionMenuLink> = [
  // 9.R.2 — Tests & Qualité (rapport statique JSON curé, pas d'exécution live).
  // Les 3 liens docs internes (9.R.1) sont retirés — cf. header (finding S4).
  { href: "/internal/quality/tests", i18nKey: "quality.menu.label" },
];
